import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const ClockSVG = ({
  fill = '#F9421D',
  size = '25',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Z"
        fill={fill}
      />
      <g clipPath="url(#a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm3.15 8.4h-3.144a.9.9 0 0 1-.875-.875V8.509a.875.875 0 0 1 1.75 0v3.137h2.269a.875.875 0 1 1 0 1.75v.004Z"
          fill="#fff"
        />
      </g>
    </svg>
  </span>
);

export default ClockSVG;
